import React from 'react';
import {Nav, Navbar, NavDropdown} from 'react-bootstrap';
import {Help} from '../../../system/buttons';
import {SaleComponent} from '../../../system/sale';
import {SaleButtonClassName} from '../../../system/sale';
import apple from '../../../app-store.png';
import android from '../../../google-play.png';
import {DASHBOARD_ROUTES} from './DashboardRoutes';
import {buildRoute} from '../navigationUtils';
import './DashboardNavigationTopBar.css';
import {BroPlanTopBarButton} from './broplan/BroPlanTopBarButton';

export type DashboardNavigationTopBarProps = {
  email?: string;
  isPublic?: boolean;
};

export const DashboardNavigationTopBar = ({
  email,
  isPublic = false,
}: DashboardNavigationTopBarProps) => {
  return (
    <Navbar collapseOnSelect className="Nav">
      <Navbar.Brand className="Nav-link" href="https://pulsoid.net/">
        <svg
          width="105"
          height="32"
          viewBox="0 0 105 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M0 8V31H3V25H13V8H0ZM10 22H3V11H10V22Z" fill="white" />
          <path d="M29 8H32V25H19V8H22V22H29V8Z" fill="white" />
          <path d="M41 0H38V25H41V0Z" fill="white" />
          <path d="M50 15H58V25H46V22H55V18H47V8H57V11H50V15Z" fill="white" />
          <path d="M64 8V25H77V8H64ZM74 22H67V11H74V22Z" fill="white" />
          <path d="M86 8H83V25H86V8Z" fill="white" />
          <path d="M86 0H83V3H86V0Z" fill="white" />
          <path
            d="M102 0V8H92V25H105V0H102ZM102 22H95.0081V11.0553H102V22Z"
            fill="white"
          />
        </svg>
      </Navbar.Brand>
      <Navbar.Brand href="https://pulsoid.net/">
        <img
          className="Nav-logo"
          src={
            'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pulsoid-index/pulsoid-logo.png'
          }
          alt="Logo"
        />
      </Navbar.Brand>
      <Navbar.Toggle aria-controls="responsive-navbar-nav" />
      <Navbar.Collapse id="responsive-navbar-nav">
        <Nav className="mr-auto">
          <Nav.Link className="Nav-link" href="https://pulsoid.net/faq">
            FAQ
          </Nav.Link>
          <Nav.Link
            className="Nav-link"
            target="_blank"
            href="https://www.blog.pulsoid.net/"
          >
            Blog
          </Nav.Link>
          {/*<Nav.Link className="Nav-link" href="https://pulsoid.net/pricing">Pricing</Nav.Link>*/}
          <Nav.Link className="Nav-link" href="https://pulsoid.net/contact">
            Contact us
          </Nav.Link>
          <Nav.Link className="Nav-link" href="https://pulsoid.net/api-faq">
            API
          </Nav.Link>
          <Nav.Link
            className="Nav-link"
            href="https://www.blog.pulsoid.net/monitors?from=mheader"
          >
            Supported devices
          </Nav.Link>
          <Nav.Link className="Nav-link" href="https://pulsoid.net/s/ios-app">
            <img className="Nav-logo" src={apple} alt="Logo" />
          </Nav.Link>
          <Nav.Link
            className="Nav-link"
            href="https://pulsoid.net/s/android-app"
          >
            <img className="Nav-logo" src={android} alt="Logo" />
          </Nav.Link>
          {!isPublic && <BroPlanTopBarButton />}
        </Nav>
        {!isPublic ? (
          <>
            <Nav>
              <NavDropdown
                color="white"
                alignRight
                title={<span style={{color: 'white'}}>Account </span>}
                id="collasible-nav-dropdown"
                style={{color: 'white', alignItems: 'center'}}
                className={'d-flex'}
              >
                <NavDropdown.Item
                  href={buildRoute({path: DASHBOARD_ROUTES.PROFILE_SETTINGS})}
                >
                  {email}
                </NavDropdown.Item>
                <NavDropdown.Item
                  href={buildRoute({path: DASHBOARD_ROUTES.PROFILE_SETTINGS})}
                >
                  Settings
                </NavDropdown.Item>
                <NavDropdown.Item href="/logout">Logout</NavDropdown.Item>
              </NavDropdown>
            </Nav>
          </>
        ) : (
          <Nav.Link
            className="Nav-link"
            target="_self"
            href="https://pulsoid.net/ui/dashboard"
          >
            Dashboard
          </Nav.Link>
        )}
      </Navbar.Collapse>
    </Navbar>
  );
};
